import { render, staticRenderFns } from "./adminGAGLayout.pug?vue&type=template&id=720f6f65&lang=pug&"
import script from "./adminGAGLayout.js?vue&type=script&lang=js&"
export * from "./adminGAGLayout.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720f6f65')) {
      api.createRecord('720f6f65', component.options)
    } else {
      api.reload('720f6f65', component.options)
    }
    module.hot.accept("./adminGAGLayout.pug?vue&type=template&id=720f6f65&lang=pug&", function () {
      api.rerender('720f6f65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/index.vue"
export default component.exports